module.exports = __webpack_public_path__ + "static/img/3-2.5158978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/3-2.png
// module id = JsuI
// module chunks = 10